import { RouteLocationNormalized } from 'vue-router';

import { isPublicRoute } from '@/routerAccess';
import { useAccessContextStore } from '@/stores/accessContextStore';
import { useAuthStore } from '@/stores/auth';

/* ------------------------------------------------------------
 * Check if we need to redirect to the onboarding or start free trial
 * ------------------------------------------------------------ */
export default function subscriptionAndOnboardingGuard(
    to: RouteLocationNormalized
) {
    const authStore = useAuthStore();
    const accessContextStore = useAccessContextStore();

    if (isPublicRoute(to) || !authStore.isAuthenticated) {
        return true;
    }

    if (
        (to.path === '/start-free-trial' || to.path === '/onboarding') &&
        accessContextStore.isSubscriptionRequired
    ) {
        return '/subscription-required';
    }

    if (
        to.path === '/start-free-trial' &&
        accessContextStore.hasActiveSubscription
    ) {
        return accessContextStore.hasCompletedOnboarding ? '/' : '/onboarding';
    }

    if (
        to.path === '/onboarding' &&
        accessContextStore.hasCompletedOnboarding
    ) {
        return accessContextStore.hasActiveSubscription
            ? '/'
            : '/start-free-trial';
    }

    if (
        to.path === '/subscription-required' &&
        !accessContextStore.isSubscriptionRequired
    ) {
        return accessContextStore.hasActiveSubscription
            ? '/'
            : '/start-free-trial';
    }

    if (
        !to.meta.allowWithoutSubscription &&
        accessContextStore.isSubscriptionRequired
    ) {
        return '/subscription-required';
    }

    if (
        !to.meta.allowWithoutSubscription &&
        !accessContextStore.hasActiveSubscription
    ) {
        return '/start-free-trial';
    }

    if (
        !to.meta.allowWithoutOnboarding &&
        !accessContextStore.hasCompletedOnboarding
    ) {
        return '/onboarding';
    }

    return true;
}
